import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { CanonicalService } from '../../shared/canonical.service';

@Component({
  selector: 'app-rbi-control-solution',
  templateUrl: './rbi-control-solution.component.html',
  styleUrls: ['./rbi-control-solution.component.css']
})
export class RbiControlSolutionComponent implements OnInit {

  heading = "Solution for Digital Payments Security Controls for Mobile Banking Apps";
  subheading = "AppProtectt – Fully Comply Your Mobile Banking Apps as per RBI Digital Payment Security Guidelines";
  innerWidth:number = window.innerWidth;

  constructor(private titleService: Title, private metaTagService: Meta, private metaTagService1: Meta, private canonicalService: CanonicalService) {
    this.canonicalService.setCanonicalURL("https://www.protectt.ai/mobile-device-security");
   }

  ngOnInit(): void {
    this.titleService.setTitle('The Digital Payment Security Control Solutions for Mobile Banking Apps | RBI Compliances | Protectt.ai');
    this.metaTagService1.updateTag({name: 'title', content: 'The Digital Payment Security Control Solutions for Mobile Banking Apps | RBI Compliances | Protectt.ai'});
    this.metaTagService.updateTag({ name: 'description', content: 'Fully Comply Your Mobile Banking Apps as per RBI Digital Payment Security Guidelines. We offered the best features  like device binding, unsecured Wi-Fi security checks, anti-screen mirroring and sharing, anti-malware, MiTM Prevention, prevent tampering and reverse engineering and protection data at rest and motion.'});
  }
  onResize(event:any){
    this.innerWidth = event.target.innerWidth;
  }

}
